import script from "./PasswordRecoveryForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordRecoveryForm.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordRecoveryForm.vue?vue&type=style&index=0&id=08e91b32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e91b32"]])

export default __exports__